import { render, staticRenderFns } from "./ApplicationProcedure.vue?vue&type=template&id=675879af"
import script from "./ApplicationProcedure.vue?vue&type=script&lang=ts"
export * from "./ApplicationProcedure.vue?vue&type=script&lang=ts"
import style0 from "./ApplicationProcedure.vue?vue&type=style&index=0&id=675879af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports